export type LOCALIZATIONS = 'uk' | 'en' | 'pl';
export const LOCALIZATIONS_ARRAY: LOCALIZATIONS[] = ['uk', 'en', 'pl'];
export const DEFAULT_LOCALE: LOCALIZATIONS = 'en';
export const LOCALIZATIONS_OBJ = [
  {
    label: 'Українська',
    code: 'uk',
  },
  {
    label: 'English',
    code: 'en',
  },
  {
    label: 'Polski',
    code: 'pl',
  },
];
